import styled from "styled-components";
import { breakpoints } from "@authentic/loyalty-pwa/util/variables";

export const LayoutStyled = styled.div`
  font-family: 'Nunito Sans';
  max-width: 1127px;
  margin: 0 auto;
  padding: 32px 0;
  letter-spacing: 0.01em;
  overflow-x: hidden;
  h2 {
    font-weight: normal;
    font-size: 16px;
    text-transform: uppercase;
    font-weight: 800;
    margin: 0;
    margin-bottom: 8px;
  }

  h2, p {
    text-align: center;
  }

  display: block;
  @media screen and (max-width: 709px ) {
    display: none;
  }
`;

export const ModalStyled = styled.div`
  z-index: 3000;
  position: fixed;
  display: table;
  height:100%;
  width:100%;
  top: 0;
  left: 0;
  transform:scale(0);
  @keyframes fadeIn {
    0% {
      background:rgba(0,0,0,.0);
    }
    100% {
      background:rgba(0,0,0,.8);
    }
  }

  @keyframes fadeOut {
    0% {
      background:rgba(0,0,0,.8);
    }
    100% {
      background:rgba(0,0,0,.0);
    }
  }

  @keyframes scaleUp {
    0% {
      transform:scale(.8) translateY(1000px);
      opacity:0;
    }
    100% {
      transform:scale(1) translateY(0px);
      opacity:1;
    }
  }

  @keyframes scaleDown {
    0% {
      transform:scale(1) translateY(0px);
      opacity:1;
    }
    100% {
      transform:scale(.8) translateY(1000px);
      opacity:0;
    }
  }

  &.revealing {
    transform:scale(1);
    .modal-overlay {
      background: rgba(0,0,0,.0);
      animation: fadeIn .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
    }

    .modal-content {
      opacity:0;
      animation: scaleUp .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
    }

    &.out {
      animation: quickScaleDown 0s .5s linear forwards;
      .modal-overlay {
        animation: fadeOut .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
      }
      .modal-content {
        animation: scaleDown .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
     }
    }
  }
`;

export const ModalContentStyled = styled.div`
  background: white;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 360px;
  max-width: 100%;
  min-height: 413px;
  padding: 24px;
  overflow: initial;
  display: block;
  margin-left: -180px;
  margin-top: -237.5px;

  .modal-close-button {
    cursor: pointer;
    svg {
      position: absolute;
      top: -28px;
      right: 0;
      display: block;
      width: 16px;
      height: 16px;
    }
  }
  @media screen and (max-width: ${breakpoints.xss} ) {
    width: 320px;
    margin-left: -160px;
  }
`;

export const ModalOverlayStyled = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.8);
  display:table-cell;
`;

export const RewardsWidgetWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 48px;
  margin-bottom: 30px;
`

export const RewardDetailStyled = styled.div`
  text-align: center;
  font-family: 'Nunito Sans';
  img {
    width: 183px;
  }
  .title {
    font-weight: 700;
    font-size: 18px;
    display: block;
  }
  .subtitle {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  p {
    font-weight: 400;
    margin-bottom: 24px;
    margin-top: 12px;
  }
  .link-button {
    text-decoration: underline;
    display: block;
    margin: 24px 0 0;
    cursor: pointer;
  }
`;